export default "__VITE_ASSET__f87fe8b7__"